/**
 * userColors.js — User identity color palette & helpers
 *
 * Each user/crew member picks an accent color from a curated palette.
 * All colors are tested for ≥3:1 contrast on white and look good on dark navy sidebar.
 */

export const ACCENT_PALETTE = [
  { hex: '#13B5EA', name: 'Xero Blue' },
  { hex: '#2563EB', name: 'Royal Blue' },
  { hex: '#7C3AED', name: 'Violet' },
  { hex: '#9333EA', name: 'Purple' },
  { hex: '#DB2777', name: 'Pink' },
  { hex: '#DC2626', name: 'Red' },
  { hex: '#EA580C', name: 'Orange' },
  { hex: '#CA8A04', name: 'Amber' },
  { hex: '#059669', name: 'Emerald' },
  { hex: '#0D9488', name: 'Teal' },
  { hex: '#475569', name: 'Slate' },
  { hex: '#1B2A4A', name: 'Navy' },
];

/**
 * Hash-based fallback color for people without a stored accent_color.
 * Returns an HSL string derived from the name.
 */
export function hashColor(name) {
  if (!name) return '#475569';
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return `hsl(${Math.abs(h) % 360}, 55%, 45%)`;
}

/**
 * Get the display color for a person object.
 * Checks accentColor / accent_color, then falls back to hash.
 */
export function getUserColor(person) {
  if (!person) return '#475569';
  return person.accentColor || person.accent_color || hashColor(person.name || person.full_name || '');
}

/**
 * URL of the scraped RE-agent headshot for a prospect name.
 * Filename convention: "First Last" → "First_Last.jpg" (apostrophes/dots/dashes stripped).
 */
export function agentPhotoUrl(name) {
  if (!name) return '';
  const filename = name.replace(/['\.\-]/g, '').replace(/ /g, '_') + '.jpg';
  return `/api/agent-photos/${encodeURIComponent(filename)}`;
}

/**
 * Get initials from a name string (max 2 chars).
 */
export function getInitials(name) {
  if (!name) return '?';
  return name
    .split(' ')
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
}
